/* eslint-disable no-unused-vars */
export enum TagType {
  None = 'none',
  Text = 'text',
  Image = 'image',
  Gallery = 'gallery',
  Music = 'music',
  Video = 'video',
  Iframe = 'iframe',
  Tab = 'tab',
  Panorama = 'panorama',
  Menu = 'menu',
  Matterport = 'matterport',
  MatterportInstant = 'matterport-instant',
  Treedis = 'treedis',
  VideoChat = 'video-chat',
  ConferenceChat = 'conference-chat',
  Navigation = 'navigation',
}

export enum TagNavigationType {
  Menu = 'menu',
  Polygon = 'polygon',
  Tag = 'tag',
}

export enum TagRes {
  Percentage = 'percentage',
  Pixels = 'pixels',
}

export interface Tag {
  id?: number;
  title: string;
  sid: string;
  defaultSid?: string;
  bookColor: string;
  bookText: string;
  bookUrl: string;
  url: string;
  urlMobile: string;
  type: TagType;
  res: TagRes;
  enabled: boolean;
  height: number;
  width: number;
  heightMobile: number;
  widthMobile: number;
  custom: boolean;
  description: string;
  iconColor: string;
  icon: string;
  opacity: number;
  positionX: number;
  positionY: number;
  positionZ: number;
  stemVectorX: number;
  stemVectorY: number;
  stemVectorZ: number;
  svXEnabled: boolean;
  svYEnabled: boolean;
  svZEnabled: boolean;
  text: string;
  iconFile: string;
  panoramaId: number;
  menuId: number;
  subMenuId: number;
  subSubMenuId: number;
  whiteCircle: boolean;
  transparentBackground: boolean;
  mpTitle: boolean;
  mpTooltip: boolean;
  mpNavigation: boolean;
  gameBackpack: boolean;
  tagGalleries: any[];
  navigationId: string;
  navigationType: TagNavigationType;
  navigationLink: string;
  fullscreen: boolean;
  autoPlay: boolean;
  embedMedia: boolean;
}
